module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAP/+EP//EP/9Ef/9EP/8Ef/7Ef/5EYaGhjUkADUcED0YDBQcAFEEBBwQCCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABgALAAAAAAgACAAAAXAICaOZGmeaHmtV+qiVyCvby3Gct7aKZ7rvJNPh9sFb78ZK0A7DpVLVvDJZOEkk+aLah1mm4deklXhsg5h2O/ypc4gq7SwCPkmkxCJVgh1JylSYlV3hFV7Jn6FYy4sFoo/dkyMKxSPARWRkj1LhQoKFxaOQJsrhAmfF3o/GEZzFwtJDw8sEqusWysNOQgOtEk3LwcrETEXCCwMhLcpaMKllBS1hK24hn7UNYmjR6yP2FOF304yIjPcMCTi56yB6+4hADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadSE_S4.gif
// module id = XfX4
// module chunks = 50